const testimonials = [
  {
    name: "Chief Petty Officer Mark T.",
    location: "NAS Jacksonville, FL",
    rating: 5,
    text: "Received PCS orders to Yokosuka with 18 days to report. My wife's passport had expired and our daughter never had one. Fast Passport Center walked us through the dependent process, reviewed every document, and got both passports back in six business days. That is the difference between making my report date and missing it. Cannot recommend them enough to any military family.",
    service: "Family Expedited Passports",
  },
  {
    name: "Jennifer K.",
    location: "Riverside, Jacksonville",
    rating: 5,
    text: "I am a project manager at a logistics firm downtown and booked a client site visit to London with two weeks notice. My passport expired during COVID when I was not traveling. Fast Passport Center had my renewal processed and back to me in five business days. I made my flight out of JAX without a single hiccup. Professional, fast, and worth every penny.",
    service: "Passport Renewal",
  },
  {
    name: "David & Sarah M.",
    location: "Fleming Island, FL",
    rating: 5,
    text: "We booked a Bahamas cruise out of JAXPORT for our anniversary and realized the week before that Sarah's passport was expired. Panic mode. Called Fast Passport Center on Monday, shipped documents overnight from Orange Park, and had her new passport Thursday afternoon. We sailed Saturday morning. Honestly have no idea what we would have done without them.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function JacksonvilleTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Northeast Florida Travelers Say About Our Emergency & Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Jacksonville, NAS Jacksonville, and Fleming Island travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}